import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ action, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full bg-card rounded-lg border border-border p-4 md:p-5 hover:shadow-lg hover:border-primary/50 transition-all duration-300 text-left group"
    >
      <div className="flex items-start gap-3 md:gap-4">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${action?.bgColor} group-hover:scale-110 transition-transform duration-300`}>
          <Icon name={action?.icon} size={20} className="md:w-6 md:h-6" color={action?.iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-1 line-clamp-1">
            {action?.title}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {action?.description}
          </p>
        </div>
        <Icon 
          name="ChevronRight" 
          size={18} 
          className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-300 flex-shrink-0" 
        />
      </div>
    </button>
  );
};

export default QuickActionCard;